import { render, staticRenderFns } from "./GridForm.vue?vue&type=template&id=679eaeaf&"
import script from "./GridForm.vue?vue&type=script&lang=ts&"
export * from "./GridForm.vue?vue&type=script&lang=ts&"
import style0 from "./GridForm.vue?vue&type=style&index=0&id=679eaeaf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports